import { createAction, union, props } from '@ngrx/store';

export const setViewedNotification = createAction('[Common] setViewedNotification', props<{ id: number }>());
export const clearViewedNotification = createAction('[Common] clearViewedNotification', props<{ id: number }>());
export const clearAllViewedNotification = createAction('[Common] clearViewedNotification');

const all = union({ setViewedNotification, clearViewedNotification, clearAllViewedNotification });

export type NotificationsActionsUnion = typeof all;
